import { FaCircle } from "react-icons/fa";
import { useSelector } from "react-redux"
import { useEffect } from "react";

function PaymentMethodsNew({selectedPayment, setSelectedPayment}){
    const isCOD = useSelector((state) => state.fetchUser?.user?.isCOD);
      useEffect(() => {
    if (typeof isCOD === "boolean") {
      if (isCOD && !selectedPayment) {
        setSelectedPayment("COD");
      } else if (!isCOD) {
        setSelectedPayment("PREPAID");
      }
    }
  }, [isCOD, selectedPayment, setSelectedPayment]);
    return (
        <>
            
            <div className="card-box cart-payment-box">
                                    <div className="cart-heading"><h3 className="h3 heading heading-light">Payment Method</h3></div>
                                    <ul className="list">
                                        <li className={` radio-icon-box ${selectedPayment === "PREPAID" ?'selected-item':''}`}><div className="icon-box"><FaCircle/> <input type="radio" name="payment" id="onlinePayment"  value="PREPAID"
                               checked={selectedPayment === "PREPAID"}
                               onChange={() => setSelectedPayment("PREPAID")}/></div> <label htmlFor="onlinePayment"><span>Online Payment</span></label></li>
                               {isCOD && (
                                        <li className={` radio-icon-box ${selectedPayment === "COD" ?'selected-item':''}`}><div className="icon-box"><FaCircle/> <input type="radio"  id="codPayment" name="payment" value="COD"  checked={selectedPayment === "COD"}
                               onChange={() => setSelectedPayment("COD")}/></div> <label htmlFor="codPayment"><span>Cash on Delivery</span></label></li>)}
                                    </ul>
                                </div>
        </>
    )
}
export default PaymentMethodsNew